<template>
    <header class="patsnap-biz-mobile-nav-bar h-[46px] w-full px-5 items-center gap-4">
        <slot name="logo">
            <img src="./assets/icon/Logo.png" alt="mini-logo" class="!h-6">
        </slot>
        <i class="grow" />
        <div>
            <slot name="avatar" />
        </div>
    </header>
</template>

<script setup lang="ts">
</script>
